// extracted by mini-css-extract-plugin
export default {"skillsHeader":"Experience_skillsHeader__MKNzI","skills":"Experience_skills__QJ9IC","langLogos":"Experience_langLogos__bOdMS"};